import { fetchEventSource } from "@microsoft/fetch-event-source";

export class SseClient {
  constructor(dotnetContext) {
    this.dotNetHelper = dotnetContext;
    this.controller = null;
  }

  async start(url, options = {}) {
    this.stop(); // Ensure any existing connection is stopped

    this.controller = new AbortController();

    const defaultOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      signal: this.controller.signal,
      onmessage: this.onMessage.bind(this),
      onopen: this.onOpen.bind(this),
      onclose: this.onClose.bind(this),
      onerror: this.onError.bind(this),
    };

    const fetchOptions = { ...defaultOptions, ...options };

    try {
      // Create a promise that resolves when the Blazor cancellation token is triggered
      const cancellationPromise = new Promise((_, reject) => {
        this.dotNetHelper.invokeMethodAsync("RegisterCancellation").then(() => {
          reject(new Error("Operation cancelled by Blazor"));
        });
      });

      // Race between the fetchEventSource and the cancellation promise
      await Promise.race([
        fetchEventSource(url, fetchOptions),
        cancellationPromise,
      ]);
    } catch (err) {
      if (err.message === "Operation cancelled by Blazor") {
        console.log("SSE connection cancelled by Blazor");
      } else {
        console.error("fetchEventSource error:", err);
        // Implement retry logic here if needed
      }
      this.stop();
    }
  }

  stop() {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  onMessage(event) {
    this.dotNetHelper?.invokeMethodAsync("OnEventReceived", event.data);
  }

  onOpen(response) {
    if (response.ok && response.status === 200) {
      console.log("SSE connection opened");
    } else {
      console.error(
        "SSE connection failed:",
        response.status,
        response.statusText,
      );
      throw new Error(
        `Failed to open SSE connection: ${response.status} ${response.statusText}`,
      );
    }
  }

  onClose() {
    console.log("SSE connection closed");
  }

  onError(err) {
    console.error("SSE error:", err);
  }
}
